import { FC } from 'react';

import { Box, Divider, Typography } from '@mui/material';

import { LogoGrid } from './LogoGrid';

/**
 * Right-side screen shown on desktop during onboarding.
 * Displays the application preview image and "Trusted By" logos section.
 * Sticky positioned to stay visible while scrolling the onboarding form.
 */
export const OnboardingImageScreen: FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        height: '100vh',
        backgroundColor: 'background.default',
        overflow: 'hidden',
        position: 'sticky',
        top: 0
      }}
    >
      <Box
        sx={{
          py: '10vh',
          px: '3vw',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8vh',
          flex: 1
        }}
      >
        <Box sx={{ overflow: 'hidden', width: '100%', transform: 'translateX(5vw)' }}>
          <img
            alt='GX GO application preview'
            decoding='async'
            fetchPriority='high'
            loading='eager'
            src='/img/login-image.png'
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              objectPosition: 'right'
            }}
          />
        </Box>
        <Box
          sx={{
            width: '100%'
          }}
        >
          <Divider
            sx={{
              '&::before': { borderTop: '1px solid #F8F8F8' },
              '&::after': { borderTop: '1px solid #F8F8F8' },
              margin: 0
            }}
            variant='middle'
          >
            <Typography>Trusted By</Typography>
          </Divider>
          <LogoGrid />
        </Box>
      </Box>
    </Box>
  );
};
